import { render } from "./TimelineYear.vue?vue&type=template&id=853199a6"
import script from "./TimelineYear.vue?vue&type=script&lang=js"
export * from "./TimelineYear.vue?vue&type=script&lang=js"

import "./TimelineYear.vue?vue&type=style&index=0&id=853199a6&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__